export default __webpack_public_path__ + "static/media/professional_services_firms.56ae2587.svg";